import { Tooltip, TooltipProps } from '@tonic-one/react';
import { ReactNode } from 'react';

const ConditionalTooltip = (
  props: {
    condition: boolean;
    children: ReactNode;
  } & TooltipProps
) => {
  const { condition, children, ...tooltipProps } = props;
  return condition ? (
    <Tooltip shouldWrapChildren {...tooltipProps}>
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  );
};

export default ConditionalTooltip;
